export default __webpack_public_path__ + "media/images/icons/icon-social-fb-ccb8b39f545fb1692acca51e3ccc2705.svg";